import { render, staticRenderFns } from "./__TemBichOdd.vue?vue&type=template&id=b075c988&"
import script from "./__TemBichOdd.vue?vue&type=script&lang=js&"
export * from "./__TemBichOdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports